import { fetchModel as fetchSharedModel } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/model';
import type { CloneReservationState } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/cloneReservation';

/** Load the editor and its revision together so Clone cannot silently use a newer saved quote. */
export async function fetchModel(url: string, signal?: AbortSignal): Promise<CloneReservationState> {
    const baseUrl = (typeof document !== 'undefined' && document.baseURI) || window.location.href;
    const sourceUrl = new URL(url, baseUrl);
    let id = sourceUrl.searchParams.get('reservationId');
    if (!id) {
        // A booking popup first resolves its parent reservation through the ordinary read endpoint.
        const resolved = await fetchSharedModel(url, signal);
        id = resolved.ReservationId;
        if (!id) return resolved;
        sourceUrl.searchParams.set('reservationId', id);
        sourceUrl.searchParams.delete('bookingId');
    }
    const response = await fetch(`/clone-reservation/${encodeURIComponent(id)}/version`, { signal });
    if (!response.ok) throw new Error('Could not load the saved reservation. Reload and try again.');
    const version: number = await response.json();
    sourceUrl.searchParams.set('version', String(version));
    // Keep the ordinary popup endpoint, including its tenant-specific model enrichment.
    const reservation: CloneReservationState = await fetchSharedModel(`${sourceUrl.pathname}${sourceUrl.search}`, signal);
    reservation.SavedSourceVersion = version;
    return reservation;
}
